import { AbstractControl, ValidationErrors } from '@angular/forms';

export function loopSettingsIntegerValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value === '' || control.value === null || control.value === undefined) {
    return null;
  }
  const value = Number(control.value);
  return Number.isSafeInteger(value) && value > 0 ? null : { positiveSafeInteger: true };
}
